import { InjectionToken } from '@angular/core';

export const IOTEQ_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>('IOTEQ_MOCK_API_DEFAULT_DELAY');
